var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicationMaintenanceThoroughSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 4.5,
    fill: "black",
    stroke: "#DC2418"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_396_54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4987 33.5355C35.4514 31.5829 35.4514 28.4171 33.4987 26.4645C31.5461 24.5118 28.3803 24.5118 26.4277 26.4645C24.475 28.4171 24.475 31.5829 26.4277 33.5355C28.3803 35.4882 31.5461 35.4882 33.4987 33.5355Z",
    stroke: "#DC2418",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.802 38.8388C43.6836 33.9573 43.6836 26.0427 38.802 21.1612C33.9205 16.2796 26.0059 16.2796 21.1244 21.1612C16.2428 26.0427 16.2428 33.9573 21.1244 38.8388C26.0059 43.7204 33.9205 43.7204 38.802 38.8388Z",
    stroke: "#DC2418",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.25 21.25L26.25 26.25",
    stroke: "#DC2418",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.75 26.25L38.75 21.25",
    stroke: "#DC2418",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.75 33.75L38.75 38.75",
    stroke: "#DC2418",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.25 33.75L21.25 38.75",
    stroke: "#DC2418",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_396_54"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationMaintenanceThoroughSupport);
export default __webpack_public_path__ + "static/media/applicationMaintenanceThoroughSupport.269ad0f5629d30c0625af79b462ebdc6.svg";
export { ForwardRef as ReactComponent };